import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M22.105 9.684a2.684 2.684 0 1 1-5.368 0 2.684 2.684 0 0 1 5.368 0m-10.737 5.369a2.684 2.684 0 1 1-5.367 0 2.684 2.684 0 0 1 5.367 0M23 21.316a2.684 2.684 0 1 1-5.368 0 2.684 2.684 0 0 1 5.368 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.768 8.862a7 7 0 0 0-1.04-.072 7.29 7.29 0 0 0-6.38 3.724M21.4 11.47a7.07 7.07 0 0 1 .728 7.88m-4.155 3.408a7.3 7.3 0 0 1-2.245.348c-3.391 0-6.24-2.286-7.045-5.377"
    }, null, -1)
  ])))
}
export default { render: render }